import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const ConsultaExcepciones = () => {
  const [filtros, setFiltros] = useState({
    cadeteDni: "",
    fechaDesde: "",
    fechaHasta: "",
    tipo: "Todos",
    estado: "Todos",
  });

  const [resultado, setResultado] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  const API =
    "https://wwwa.isepsantafe.net.ar/expedientes/cadetes/consultarExcepciones";

  // ============================================================
  // TIPOS
  // ============================================================

  const tiposExcepcion = [
    "Todos",
    "Tramites personales",
    "Motivos Economicos",
  ];

  // Si tenés más valores del ENUM de excepciones,
  // simplemente los agregamos acá.

  const estados = [
    "Todos",
    "Activo",
    "Desactivado",
  ];

  // ============================================================
  // CAMBIO DE FILTROS
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFiltros((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ============================================================
  // CONSULTAR
  // ============================================================

  const consultar = async () => {
    try {
      setCargando(true);
      setError("");

      const body = {};

      if (filtros.cadeteDni.trim()) {
        body.cadeteDni = filtros.cadeteDni.trim();
      }

      if (filtros.fechaDesde) {
        body.fechaDesde = filtros.fechaDesde;
      }

      if (filtros.fechaHasta) {
        body.fechaHasta = filtros.fechaHasta;
      }

      if (filtros.tipo !== "Todos") {
        body.tipo = filtros.tipo;
      }

      if (filtros.estado !== "Todos") {
        body.estado = filtros.estado;
      }

      console.log(
        "📤 Consultando avisos:",
        body
      );

      const response =
        await axios.post(API, body);

      console.log(
        "📥 Resultado avisos:",
        response.data
      );

      if (response.data?.success) {
        setResultado(response.data);
      } else {
        setResultado(null);

        setError(
          response.data?.message ||
            "No se pudieron obtener los avisos."
        );
      }
    } catch (err) {
      console.error(
        "💥 Error consultando avisos:",
        err
      );

      setResultado(null);

      setError(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Ocurrió un error al consultar los avisos."
      );
    } finally {
      setCargando(false);
    }
  };

  // ============================================================
  // LIMPIAR
  // ============================================================

  const limpiar = () => {
    setFiltros({
      cadeteDni: "",
      fechaDesde: "",
      fechaHasta: "",
      tipo: "Todos",
      estado: "Todos",
    });

    setResultado(null);
    setError("");
  };

  // ============================================================
  // NOMBRE COMPLETO
  // ============================================================

  const nombreCompleto = (item) => {
    return `${
      item.cadeteApellido || ""
    } ${
      item.cadeteNombre || ""
    }`.trim();
  };

  // ============================================================
  // DESCARGAR EXCEL
  // ============================================================

  const descargarExcel = () => {
    try {
      if (
        !resultado?.excepciones ||
        resultado.excepciones.length === 0
      ) {
        alert(
          "No hay excepciones para exportar."
        );

        return;
      }

      // ========================================================
      // DATOS PRINCIPALES
      // ========================================================

      const datosExcel =
        resultado.excepciones.map(
          (item, index) => ({
            Nro: index + 1,

            Fecha:
              item.fecha || "",

            Hora:
              item.hora || "",

            DNI:
              item.cadeteDni || "",

            Apellido:
              item.cadeteApellido || "",

            Nombre:
              item.cadeteNombre || "",

            Condicion:
              item.cadeteCondicion || "",

            EstadoCadete:
              item.cadeteEstado || "",

            Sede:
              item.cadeteSede || "",

            Seccion:
              item.seccionNombre || "",

            Compania:
              item.companiaNombre || "",

            TipoExcepcion:
              item.tipo || "",

            EstadoExcepcion:
              item.estado || "",

            Descripcion:
              item.descripcion || "",
          })
        );

      // ========================================================
      // HOJA EXCEPCIONES
      // ========================================================

      const hojaExcepciones =
        XLSX.utils.json_to_sheet(
          datosExcel
        );

      hojaExcepciones["!cols"] = [
        { wch: 6 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 22 },
        { wch: 22 },
        { wch: 16 },
        { wch: 16 },
        { wch: 16 },
        { wch: 18 },
        { wch: 18 },
        { wch: 25 },
        { wch: 18 },
        { wch: 50 },
      ];

      if (datosExcel.length > 0) {
        hojaExcepciones[
          "!autofilter"
        ] = {
          ref: `A1:N${
            datosExcel.length + 1
          }`,
        };
      }

      // ========================================================
      // HOJA RESUMEN
      // ========================================================

      const resumenExcel = [
        {
          Concepto: "Total de excepciones",
          Cantidad:
            resultado.resumen
              ?.cantidad || 0,
        },

        {
          Concepto: "Cadetes involucrados",
          Cantidad:
            resultado.resumen
              ?.cantidadCadetes || 0,
        },
      ];

      // --------------------------------------------------------
      // POR TIPO
      // --------------------------------------------------------

      if (
        resultado.resumen?.porTipo
      ) {
        Object.entries(
          resultado.resumen.porTipo
        ).forEach(
          ([tipo, cantidad]) => {
            resumenExcel.push({
              Concepto: `Tipo: ${tipo}`,
              Cantidad: cantidad,
            });
          }
        );
      }

      // --------------------------------------------------------
      // POR ESTADO
      // --------------------------------------------------------

      if (
        resultado.resumen?.porEstado
      ) {
        Object.entries(
          resultado.resumen.porEstado
        ).forEach(
          ([estado, cantidad]) => {
            resumenExcel.push({
              Concepto:
                `Estado: ${estado}`,
              Cantidad: cantidad,
            });
          }
        );
      }

      const hojaResumen =
        XLSX.utils.json_to_sheet(
          resumenExcel
        );

      hojaResumen["!cols"] = [
        { wch: 35 },
        { wch: 15 },
      ];

      // ========================================================
      // HOJA FILTROS
      // ========================================================

      const filtrosExcel = [
        {
          Filtro: "DNI",
          Valor:
            filtros.cadeteDni ||
            "Todos",
        },

        {
          Filtro: "Desde",
          Valor:
            filtros.fechaDesde ||
            "Sin límite",
        },

        {
          Filtro: "Hasta",
          Valor:
            filtros.fechaHasta ||
            "Sin límite",
        },

        {
          Filtro: "Tipo",
          Valor:
            filtros.tipo ||
            "Todos",
        },

        {
          Filtro: "Estado",
          Valor:
            filtros.estado ||
            "Todos",
        },
      ];

      const hojaFiltros =
        XLSX.utils.json_to_sheet(
          filtrosExcel
        );

      hojaFiltros["!cols"] = [
        { wch: 20 },
        { wch: 35 },
      ];

      // ========================================================
      // CREAR LIBRO
      // ========================================================

      const workbook =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        hojaExcepciones,
        "Excepciones"
      );

      XLSX.utils.book_append_sheet(
        workbook,
        hojaResumen,
        "Resumen"
      );

      XLSX.utils.book_append_sheet(
        workbook,
        hojaFiltros,
        "Filtros"
      );

      // ========================================================
      // NOMBRE ARCHIVO
      // ========================================================

      let nombreArchivo =
        "Excepciones_ISeP";

      if (filtros.cadeteDni) {
        nombreArchivo +=
          `_DNI_${filtros.cadeteDni}`;
      }

      if (filtros.fechaDesde) {
        nombreArchivo +=
          `_desde_${filtros.fechaDesde}`;
      }

      if (filtros.fechaHasta) {
        nombreArchivo +=
          `_hasta_${filtros.fechaHasta}`;
      }

      nombreArchivo += ".xlsx";

      XLSX.writeFile(
        workbook,
        nombreArchivo
      );
    } catch (error) {
      console.error(
        "Error generando Excel:",
        error
      );

      alert(
        "No se pudo generar el archivo Excel."
      );
    }
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div style={styles.page}>
      <div style={styles.container}>

        {/* =================================================== */}
        {/* CABECERA */}
        {/* =================================================== */}

        <div style={styles.header}>
          <div>
            <div style={styles.headerLabel}>
              ISeP
            </div>

            <h1 style={styles.title}>
              Consulta de Avisos Cadetes
            </h1>

            <p style={styles.subtitle}>
              Consulta histórica de avisos registrados a cadetes
            </p>
          </div>

          {resultado && (
            <div style={styles.totalHeader}>
              <span style={styles.totalNumero}>
                {resultado.cantidad || 0}
              </span>

              <span style={styles.totalTexto}>
                registros
              </span>
            </div>
          )}
        </div>

        {/* =================================================== */}
        {/* FILTROS */}
        {/* =================================================== */}

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h2 style={styles.cardTitle}>
                Filtros de búsqueda
              </h2>

              <p style={styles.cardSubtitle}>
                Podés utilizar uno o varios criterios
              </p>
            </div>
          </div>

          <div style={styles.filtersGrid}>

            {/* DNI */}

            <div style={styles.field}>
              <label style={styles.label}>
                DNI
              </label>

              <input
                type="number"
                name="cadeteDni"
                value={filtros.cadeteDni}
                onChange={handleChange}
                placeholder="Ej: 36860924"
                style={styles.input}
              />
            </div>

            {/* DESDE */}

            <div style={styles.field}>
              <label style={styles.label}>
                Desde
              </label>

              <input
                type="date"
                name="fechaDesde"
                value={filtros.fechaDesde}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            {/* HASTA */}

            <div style={styles.field}>
              <label style={styles.label}>
                Hasta
              </label>

              <input
                type="date"
                name="fechaHasta"
                value={filtros.fechaHasta}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            {/* TIPO */}

            <div style={styles.field}>
              <label style={styles.label}>
                Tipo
              </label>

              <select
                name="tipo"
                value={filtros.tipo}
                onChange={handleChange}
                style={styles.input}
              >
                {tiposExcepcion.map(
                  (tipo) => (
                    <option
                      key={tipo}
                      value={tipo}
                    >
                      {tipo}
                    </option>
                  )
                )}
              </select>
            </div>

            {/* ESTADO */}

            <div style={styles.field}>
              <label style={styles.label}>
                Estado
              </label>

              <select
                name="estado"
                value={filtros.estado}
                onChange={handleChange}
                style={styles.input}
              >
                {estados.map(
                  (estado) => (
                    <option
                      key={estado}
                      value={estado}
                    >
                      {estado}
                    </option>
                  )
                )}
              </select>
            </div>

          </div>

          {/* ================================================= */}
          {/* BOTONES */}
          {/* ================================================= */}

          <div style={styles.buttons}>
            <button
              onClick={consultar}
              disabled={cargando}
              style={{
                ...styles.btnPrimary,
                opacity:
                  cargando ? 0.65 : 1,
              }}
            >
              {cargando
                ? "Consultando..."
                : "Buscar avisos"}
            </button>

            <button
              onClick={limpiar}
              style={styles.btnSecondary}
            >
              Limpiar
            </button>

            {resultado
              ?.excepciones
              ?.length > 0 && (
              <button
                onClick={descargarExcel}
                style={styles.btnExcel}
              >
                ↓ Descargar Excel
              </button>
            )}
          </div>
        </div>

        {/* =================================================== */}
        {/* ERROR */}
        {/* =================================================== */}

        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}

        {/* =================================================== */}
        {/* RESULTADOS */}
        {/* =================================================== */}

        {resultado && (
          <>

            {/* ================================================= */}
            {/* RESUMEN GENERAL */}
            {/* ================================================= */}

            <div style={styles.summaryGrid}>

              <Resumen
                titulo="Total"
                valor={
                  resultado.resumen
                    ?.cantidad || 0
                }
              />

              <Resumen
                titulo="Cadetes"
                valor={
                  resultado.resumen
                    ?.cantidadCadetes || 0
                }
              />

              {Object.entries(
                resultado.resumen
                  ?.porEstado || {}
              ).map(
                ([estado, cantidad]) => (
                  <Resumen
                    key={`estado-${estado}`}
                    titulo={estado}
                    valor={cantidad}
                  />
                )
              )}

            </div>

            {/* ================================================= */}
            {/* RESUMEN POR TIPO */}
            {/* ================================================= */}

            {Object.keys(
              resultado.resumen
                ?.porTipo || {}
            ).length > 0 && (
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div>
                    <h2 style={styles.cardTitle}>
                      Avisos por tipo
                    </h2>

                    <p style={styles.cardSubtitle}>
                      Distribución de los registros encontrados
                    </p>
                  </div>
                </div>

                <div style={styles.summaryGridInterno}>
                  {Object.entries(
                    resultado.resumen
                      ?.porTipo || {}
                  ).map(
                    ([tipo, cantidad]) => (
                      <Resumen
                        key={tipo}
                        titulo={tipo}
                        valor={cantidad}
                      />
                    )
                  )}
                </div>
              </div>
            )}

            {/* ================================================= */}
            {/* TABLA */}
            {/* ================================================= */}

            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <div>
                  <h2 style={styles.cardTitle}>
                    Resultados
                  </h2>

                  <p style={styles.cardSubtitle}>
                    {resultado.cantidad === 1
                      ? "1 aviso encontrado"
                      : `${
                          resultado.cantidad || 0
                        } avisos encontrados`}
                  </p>
                </div>

                {resultado
                  ?.excepciones
                  ?.length > 0 && (
                  <button
                    onClick={descargarExcel}
                    style={styles.btnExcel}
                  >
                    ↓ Excel
                  </button>
                )}
              </div>

              {!resultado
                .excepciones
                ?.length ? (
                <div style={styles.empty}>
                  No se encontraron avisos con los filtros seleccionados.
                </div>
              ) : (
                <div style={styles.tableWrapper}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>
                          Fecha
                        </th>

                        <th style={styles.th}>
                          Hora
                        </th>

                        <th style={styles.th}>
                          DNI
                        </th>

                        <th style={styles.th}>
                          Cadete
                        </th>

                        <th style={styles.th}>
                          Sede
                        </th>

                        <th style={styles.th}>
                          Sección
                        </th>

                        <th style={styles.th}>
                          Compañía
                        </th>

                        <th style={styles.th}>
                          Tipo
                        </th>

                        <th style={styles.th}>
                          Descripción
                        </th>

                        <th style={styles.th}>
                          Estado
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {resultado.excepciones.map(
                        (item) => (
                          <tr
                            key={item.id}
                            style={styles.tr}
                          >
                            <td style={styles.td}>
                              <strong>
                                {item.fecha || "-"}
                              </strong>
                            </td>

                            <td style={styles.td}>
                              {item.hora || "-"}
                            </td>

                            <td style={styles.td}>
                              {item.cadeteDni || "-"}
                            </td>

                            <td style={styles.td}>
                              <div style={styles.nombre}>
                                {nombreCompleto(item) ||
                                  "Sin datos"}
                              </div>

                              {item.cadeteCondicion && (
                                <div style={styles.small}>
                                  {item.cadeteCondicion}
                                </div>
                              )}
                            </td>

                            <td style={styles.td}>
                              {item.cadeteSede || "-"}
                            </td>

                            <td style={styles.td}>
                              {item.seccionNombre || "-"}
                            </td>

                            <td style={styles.td}>
                              {item.companiaNombre || "-"}
                            </td>

                            <td style={styles.td}>
                              <TipoBadge
                                tipo={item.tipo}
                              />
                            </td>

                            <td style={styles.tdDescripcion}>
                              {item.descripcion || "-"}
                            </td>

                            <td style={styles.td}>
                              <EstadoBadge
                                estado={item.estado}
                              />
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}

        {/* =================================================== */}
        {/* SIN CONSULTA */}
        {/* =================================================== */}

        {!resultado &&
          !error &&
          !cargando && (
            <div style={styles.initial}>
              <div style={styles.initialIcon}>
                ⌕
              </div>

              <h3 style={styles.initialTitle}>
                Consulta histórica
              </h3>

              <p style={styles.initialText}>
                Seleccioná un DNI, período o cualquier combinación
                de filtros y presioná Buscar avisos.
              </p>
            </div>
          )}
      </div>
    </div>
  );
};

// ============================================================
// RESUMEN
// ============================================================

const Resumen = ({
  titulo,
  valor,
}) => {
  return (
    <div style={styles.summaryCard}>
      <div style={styles.summaryValue}>
        {valor}
      </div>

      <div style={styles.summaryLabel}>
        {titulo}
      </div>
    </div>
  );
};

// ============================================================
// BADGE TIPO
// ============================================================

const TipoBadge = ({ tipo }) => {
  let background =
    "#eef2f7";

  let color =
    "#344054";

  if (
    tipo === "Tramites personales"
  ) {
    background =
      "#eef4ff";

    color =
      "#3538cd";
  }

  if (
    tipo === "Motivos Economicos"
  ) {
    background =
      "#fff4e5";

    color =
      "#b54708";
  }

  return (
    <span
      style={{
        ...styles.badge,
        background,
        color,
      }}
    >
      {tipo || "Sin tipo"}
    </span>
  );
};

// ============================================================
// BADGE ESTADO
// ============================================================

const EstadoBadge = ({
  estado,
}) => {
  const activo =
    estado === "Activo";

  return (
    <span
      style={{
        ...styles.badge,

        background:
          activo
            ? "#ecfdf3"
            : "#f2f4f7",

        color:
          activo
            ? "#027a48"
            : "#667085",
      }}
    >
      {estado || "Sin estado"}
    </span>
  );
};

// ============================================================
// ESTILOS
// ============================================================

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f4f7f9",
    padding: "28px 16px",
    fontFamily:
      "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },

  container: {
    width: "100%",
    maxWidth: "1500px",
    margin: "0 auto",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    gap: "20px",
    flexWrap: "wrap",
  },

  headerLabel: {
    fontSize: "12px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "2px",
    color: "#3d7277",
    marginBottom: "5px",
  },

  title: {
    margin: 0,
    fontSize: "30px",
    fontWeight: "800",
    color: "#1d2939",
  },

  subtitle: {
    margin: "6px 0 0 0",
    color: "#667085",
    fontSize: "14px",
  },

  totalHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },

  totalNumero: {
    fontSize: "30px",
    fontWeight: "800",
    color: "#315f64",
    lineHeight: 1,
  },

  totalTexto: {
    fontSize: "12px",
    color: "#667085",
    marginTop: "4px",
  },

  card: {
    background: "#ffffff",
    borderRadius: "16px",
    padding: "22px",
    boxShadow:
      "0 3px 14px rgba(0,0,0,0.06)",
    border:
      "1px solid #eaecf0",
    marginBottom: "20px",
  },

  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },

  cardTitle: {
    margin: 0,
    color: "#1d2939",
    fontSize: "18px",
    fontWeight: "700",
  },

  cardSubtitle: {
    margin: "4px 0 0 0",
    color: "#667085",
    fontSize: "13px",
  },

  filtersGrid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "15px",
  },

  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  label: {
    fontWeight: "600",
    color: "#344054",
    fontSize: "13px",
  },

  input: {
    width: "100%",
    boxSizing: "border-box",
    border:
      "1px solid #d0d5dd",
    borderRadius: "9px",
    padding: "10px 12px",
    fontSize: "14px",
    background: "#ffffff",
    color: "#101828",
    outline: "none",
  },

  buttons: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
  },

  btnPrimary: {
    border: "none",
    borderRadius: "9px",
    padding: "11px 18px",
    background: "#315f64",
    color: "#ffffff",
    fontWeight: "700",
    cursor: "pointer",
    fontSize: "14px",
  },

  btnSecondary: {
    border:
      "1px solid #d0d5dd",
    borderRadius: "9px",
    padding: "11px 18px",
    background: "#ffffff",
    color: "#344054",
    fontWeight: "600",
    cursor: "pointer",
    fontSize: "14px",
  },

  btnExcel: {
    border:
      "1px solid #067647",
    borderRadius: "9px",
    padding: "11px 18px",
    background: "#ecfdf3",
    color: "#067647",
    fontWeight: "700",
    cursor: "pointer",
    fontSize: "14px",
  },

  summaryGrid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(130px, 1fr))",
    gap: "12px",
    marginBottom: "20px",
  },

  summaryGridInterno: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "12px",
  },

  summaryCard: {
    background: "#ffffff",
    border:
      "1px solid #eaecf0",
    borderRadius: "13px",
    padding: "16px",
    boxShadow:
      "0 2px 8px rgba(0,0,0,.04)",
  },

  summaryValue: {
    fontSize: "25px",
    fontWeight: "800",
    color: "#315f64",
    lineHeight: "1.1",
  },

  summaryLabel: {
    marginTop: "6px",
    color: "#667085",
    fontWeight: "600",
    fontSize: "12px",
  },

  tableWrapper: {
    overflowX: "auto",
    width: "100%",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1200px",
  },

  th: {
    textAlign: "left",
    padding: "11px 10px",
    borderBottom:
      "1px solid #eaecf0",
    background: "#f9fafb",
    color: "#475467",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: ".3px",
  },

  tr: {
    borderBottom:
      "1px solid #f2f4f7",
  },

  td: {
    padding: "12px 10px",
    color: "#344054",
    fontSize: "13px",
    verticalAlign: "middle",
  },

  tdDescripcion: {
    padding: "12px 10px",
    color: "#344054",
    fontSize: "13px",
    verticalAlign: "middle",
    minWidth: "260px",
    maxWidth: "400px",
    whiteSpace: "normal",
    lineHeight: "1.4",
  },

  nombre: {
    fontWeight: "700",
    color: "#1d2939",
  },

  small: {
    fontSize: "11px",
    color: "#98a2b3",
    marginTop: "2px",
  },

  badge: {
    display: "inline-block",
    padding: "5px 9px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "700",
    whiteSpace: "nowrap",
  },

  error: {
    padding: "14px 16px",
    borderRadius: "10px",
    background: "#fef3f2",
    border:
      "1px solid #fecdca",
    color: "#b42318",
    fontWeight: "600",
    marginBottom: "20px",
  },

  empty: {
    padding: "40px",
    textAlign: "center",
    color: "#667085",
  },

  initial: {
    background: "#ffffff",
    border:
      "1px dashed #cfd8dc",
    borderRadius: "16px",
    textAlign: "center",
    padding: "55px 20px",
  },

  initialIcon: {
    fontSize: "42px",
    color: "#527d81",
    marginBottom: "10px",
  },

  initialTitle: {
    color: "#344054",
    fontSize: "18px",
    margin: "0 0 7px",
  },

  initialText: {
    color: "#667085",
    fontSize: "14px",
    maxWidth: "500px",
    margin: "0 auto",
    lineHeight: "1.5",
  },
};

export default ConsultaExcepciones;